webpackJsonp([4],{

/***/ "0gyQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "53iv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mk-payment-section"},[_c('div',{staticClass:"col-sm-12 materialized",attrs:{"id":"invoices-table"}},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.filteredRows,"paginate":true,"rowsPerPageText":_vm.mkPaymentData.rowsPerPageText,"showFootText":true,"footLabel":_vm.tfooter.label,"footValue":_vm.totalValue,"nextText":_vm.mkPaymentData.nextText,"prevText":_vm.mkPaymentData.prevText,"styleClass":"table condensed table-hover"},scopedSlots:_vm._u([{key:"custom-columns",fn:function(props){return [(!_vm.columns[0].hidden)?_c('th',{class:props.columnHeaderClass(_vm.columns[0], 0).replace('sorting', ''),style:({width: _vm.columns[0].width ? _vm.columns[0].width : 'auto'})},[_c('el-checkbox',{attrs:{"role":"button","id":"select-all-agreements"},model:{value:(_vm.selectAll),callback:function ($$v) {_vm.selectAll=$$v},expression:"selectAll"}})],1):_vm._e(),_vm._v(" "),_vm._l((props.columns.slice(-props.columns.length + 1)),function(column,index){return (!column.hidden)?_c('th',{class:props.columnHeaderClass(column, index + 1),style:({width: column.width ? column.width : 'auto'}),on:{"click":function($event){props.sort(index + 1)}}},[_c('span',[_vm._v(_vm._s(column.label))])]):_vm._e()})]}},{key:"table-row",fn:function(props){return [_c('td',{staticClass:"text-center materialized",attrs:{"data-title":""}},[_c('el-checkbox',{attrs:{"role":"button","value":_vm.getCheckBoxValue(props)},on:{"change":function (value) { return _vm.addAgreement(value, props.row.idReferential); }}})],1),_vm._v(" "),_c('td',{staticClass:"text-left",attrs:{"data-title":"Member"}},[_c('span',{staticClass:"data-item"},[_vm._v("\n          "+_vm._s(props.row.memberNumber === _vm.agreementData.memberData.number ? '★ ' : '')+"\n          "+_vm._s(props.row.memberName)+"\n        ")])]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-title":"Date"}},[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s(props.row.date))])]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-title":"Agreement"}},[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s(props.row.agreement))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-item"},[_vm._v("("+_vm._s(props.row.agreementDescription)+")")])]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-title":"Reference Number"}},[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s(props.row.referenceNumber))])]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-title":"Description"}},[_c('span',{staticClass:"data-item",class:{'payment-done-color': props.row.balance < 0}},[_vm._v(_vm._s(props.row.description))])]),_vm._v(" "),_c('td',{staticClass:"text-right",attrs:{"data-title":"Balance"}},[_c('span',{staticClass:"data-item brand-24-green",class:{'payment-done-color': props.row.balance < 0}},[_vm._v(_vm._s('$' + props.row.balance.toFixed(2)))])])]}}])},[_c('template',{attrs:{"slot":"table-under-banner"},slot:"table-under-banner"},[(_vm.filteredRows.length === 0 && !_vm.showSpinner)?_c('alert-banner',{attrs:{"alertMessage":'This member has no open invoices. Thank you.'}}):_vm._e()],1)],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8V0X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UpdateAgreementsTACModal_vue__ = __webpack_require__("vPWJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_381df84a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_UpdateAgreementsTACModal_vue__ = __webpack_require__("nCA6");
function injectStyle (ssrContext) {
  __webpack_require__("ra/4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UpdateAgreementsTACModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_381df84a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_UpdateAgreementsTACModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AB5W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MakeAPayment_vue__ = __webpack_require__("c8tp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_14ce66ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_MakeAPayment_vue__ = __webpack_require__("YDeI");
function injectStyle (ssrContext) {
  __webpack_require__("ftvu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MakeAPayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_14ce66ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_MakeAPayment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GUdZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KScY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row billing-section"},[_c('div',{staticClass:"col-md-12 materialized",attrs:{"id":"agreements-eft-table"}},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.eftAgreements,"styleClass":"table condensed table-hover","sortable":"false"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_c('td',{staticClass:"text-center materialized",attrs:{"data-title":""}},[_c('el-checkbox',{attrs:{"role":"button","checked":true,"value":_vm.selectedEftAgreements.indexOf(props.row.agreementId) > -1,"indextab":"2"},on:{"change":function (value) { return _vm.addEftAgreement(value, props.row.agreementId  ); }}})],1),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-title":"Member"}},[_c('span',{staticClass:"data-item"},[_c('b',[_vm._v(_vm._s(props.row.memberName))])])]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-title":"Agreement"}},[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s(props.row.agreementId))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-item"},[_vm._v(_vm._s('(' + props.row.agreementType + ')'))])]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-title":"Auto-Billed"}},[_c('b',[(props.row.accountType === 'MC')?[_c('i',{staticClass:"cc-sprite mc-cc-color",class:{'overdue-card' : props.row.cardExpirationDateValue.valueOf() < _vm.moment().valueOf()}})]:(props.row.accountType === 'VISA')?[_c('i',{staticClass:"cc-sprite visa-cc-color",class:{'overdue-card' : props.row.cardExpirationDateValue.valueOf() < _vm.moment().valueOf()}})]:(props.row.accountType === 'AMX')?[_c('i',{staticClass:"cc-sprite amx-cc-color",class:{'overdue-card' : props.row.cardExpirationDateValue.valueOf() < _vm.moment().valueOf()}})]:(props.row.accountType === 'DIS')?[_c('i',{staticClass:"cc-sprite dis-cc-color",class:{'overdue-card' : props.row.cardExpirationDateValue.valueOf() < _vm.moment().valueOf()}})]:[_c('i',{staticClass:"fa fa-university fa-lg"})],_vm._v(" "),_c('span',{staticClass:"data-item col-xs-12",class:{'overdue-card' :
            !(props.row.accountType === 'SAV' || props.row.accountType === 'CHK')
            && props.row.cardExpirationDateValue.valueOf() < _vm.moment().valueOf()}},[_vm._v("\n              "+_vm._s(props.row.autoBilled)+"\n            ")]),_vm._v(" "),(props.row.cardExpirationDate)?[_c('span',{staticClass:"data-item col-xs-12",class:{'overdue-card' : props.row.cardExpirationDateValue.valueOf() < _vm.moment().valueOf()}},[_vm._v("(Exp. "+_vm._s(props.row.cardExpirationDateText)+")")])]:_vm._e()],2)])]}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MtJA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UpdateAgreementsModal_vue__ = __webpack_require__("dBCt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_00a5fb8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_UpdateAgreementsModal_vue__ = __webpack_require__("cV+n");
function injectStyle (ssrContext) {
  __webpack_require__("uKrX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UpdateAgreementsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_00a5fb8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_UpdateAgreementsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YDeI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-24",attrs:{"id":"make-payment"}},[_c('loading',{attrs:{"show":_vm.showSpinner,"label":"Loading...","overlay":true}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container mk-payment-container"},[_c('div',{staticClass:"row mk-payment-section"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row edit-form"},[_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-10 mk-payment-about"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"mk-payment-about-section materialized col-lg-6 col-md-6 col-sm-12 col-xs-12 "},[_c('div',{staticClass:"form-group materialized"},[_c('multi-select',{attrs:{"options":_vm.allMembers,"multiple":true,"searchable":false,"disabled":_vm.allMembers.length < 2,"allowEmpty":false,"closeOnSelect":false,"label":"memberFullName","id":"mk-payment-members","placeholder":"Select","track-by":"memberNumber","limit":0,"limit-text":_vm.limitText},on:{"remove":function (searchQuery, id) { return _vm.filterMember(searchQuery, id); },"select":function($event){_vm.filteredMember = ''}},model:{value:(_vm.mkPaymentData.memberFaoNames),callback:function ($$v) {_vm.$set(_vm.mkPaymentData, "memberFaoNames", $$v)},expression:"mkPaymentData.memberFaoNames"}}),_vm._v(" "),_c('label',{attrs:{"for":"mk-payment-members"}},[_vm._v("Select Members")])],1)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"container mk-payment-container"},[_c('invoices-table',{ref:"invoicesTable",attrs:{"agreementData":_vm.agreementData,"showSpinner":_vm.showSpinner,"filteredMember":_vm.filteredMember},on:{"change":function (value) {_vm.selectedAgreements = value}}}),_vm._v(" "),_c('div',{staticClass:"table-footer clearfix mk-payment-table-footer"},[_c('div',{staticClass:"pull-right"},[_c('span',{staticClass:"tfoot-text"},[_vm._v("Amount to Pay: $"+_vm._s(_vm.invoiceTotal))])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('credit-card',{attrs:{"value":_vm.creditCardData,"disabled":false,"togglable":false},on:{"input":function (nValue) { return _vm.setCreditCardData(nValue); }}}),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"row bottom-cta-button"},[_c('div',{staticClass:"col-xs-12 materialized pm-confirm-button"},[_c('button',{staticClass:"btn btn-primary pull-right",attrs:{"disabled":_vm.isPaying || _vm.selectedAgreements.length === 0 || !_vm.isCCDataSet || _vm.errors.any('paymentMethodCC')},on:{"click":function($event){_vm.payInvoices()}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPaying),expression:"isPaying"}],staticClass:"fa fa-cog fa-spin fa-fw margin-bottom security-saving-icon"}),_vm._v("Pay Now")])])])])],1),_vm._v(" "),(_vm.showModalUAgreements)?_c('update-agreements-modal',{attrs:{"agreementsEFTData":_vm.agreementsEftData,"paymentInfo":_vm.getBankInformation()},on:{"close":function($event){_vm.showPaymentConfirmation(false)},"agreeUpdate":function (value) { _vm.handleAgree(value) }}}):_vm._e(),_vm._v(" "),(_vm.showModalUAgreementsTAC)?_c('update-agreements-tac-modal',{attrs:{"paymentData":_vm.buildPaymentData(),"htmlTac":_vm.htmlTac},on:{"cancel":function($event){_vm.showPaymentConfirmation(false)},"close":function($event){_vm.showPaymentConfirmation(true)}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mk-payment-container"},[_c('div',{staticClass:"row mk-payment-section"},[_c('section',{staticClass:"col-sm-12 mk-payment-desc-header"},[_c('h3',{staticClass:"title-24"},[_vm._v("Make a Payment")]),_vm._v(" "),_c('section',{staticClass:"card-24"},[_c('div',{staticClass:"card-text-container col-sm-14"},[_c('div',{staticClass:"text-24"},[_c('p',[_vm._v("\n                Our records indicate that the following invoices are open.\n              ")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"primary-member-legend"},[_c('i',{staticClass:"fa fa-star"}),_vm._v(" Primary Member")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c8tp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__openInvoicesTable_vue__ = __webpack_require__("hmiX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_CommonBilling__ = __webpack_require__("vGe0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__("tLvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_my_account_payment__ = __webpack_require__("6zUB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_my_account_payment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_my_account_payment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__update_agreements_eft_UpdateAgreementsModal_vue__ = __webpack_require__("MtJA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__update_agreements_eft_UpdateAgreementsTACModal_vue__ = __webpack_require__("8V0X");











var payInvoicesService = __WEBPACK_IMPORTED_MODULE_3_CommonBilling__["a" /* ServiceContainer */].payInvoicesService;
var paymentUpdateService = __WEBPACK_IMPORTED_MODULE_3_CommonBilling__["a" /* ServiceContainer */].paymentUpdateService;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'make-payment',
  components: {
    'date-range': __WEBPACK_IMPORTED_MODULE_3_CommonBilling__["b" /* dateRange */],
    'loading': __WEBPACK_IMPORTED_MODULE_3_CommonBilling__["c" /* loading */],
    'multi-select': __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a,
    'invoices-table': __WEBPACK_IMPORTED_MODULE_2__openInvoicesTable_vue__["a" /* default */],
    'credit-card': __WEBPACK_IMPORTED_MODULE_6_my_account_payment__["CreditCard"],
    'update-agreements-modal': __WEBPACK_IMPORTED_MODULE_7__update_agreements_eft_UpdateAgreementsModal_vue__["a" /* default */],
    'update-agreements-tac-modal': __WEBPACK_IMPORTED_MODULE_8__update_agreements_eft_UpdateAgreementsTACModal_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showSpinner: false,
      agreementData: {},
      agreementsEftData: {},
      selectedAgreements: [],
      selectedEftAgreements: [],
      filteredMember: '',
      memberNumber: '',
      memberName: '',
      htmlTac: '',
      isPaying: false,
      rows: [],
      hasInvoiceTableLoadedData: false,
      interval: '',
      mkPaymentData: {
        memberFaoNames: [],
        memberFaos: [],
        rowsPerPageText: 'Rows:',
        nextText: '',
        prevText: ''
      },
      creditCardData: {
        nameOnCard: '',
        cardNumber: '',
        expirationMonth: '01',
        expirationYear: 2017,
        cardType: '',
        validationErrors: []
      },
      showModalUAgreements: false,
      showModalUAgreementsTAC: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    paymentUpdateService.getTacHtml({}).then(function (response) {
      _this.htmlTac = response.data;
    });
    this.showSpinner = true;
    this.populateTable();
  },

  methods: {
    populateTable: function populateTable() {
      var _this2 = this;

      this.callSearchOpenInvoices(true).then(function (response) {
        _this2.showSpinner = false;
        _this2.isPaying = false;
        _this2.selectedAgreements = [];
        _this2.setData(response.data);
        _this2.mkPaymentData.memberFaoNames = _this2.mkPaymentData.memberFaos.concat({
          'memberFullName': _this2.memberName,
          'memberNumber': _this2.memberNumber
        });
        _this2.hasInvoiceTableLoadedData = true;
      }).catch(function (error) {
        _this2.showSpinner = false;
        if (error.response !== undefined && error.response.data.errorMessage !== undefined) {
          _this2.$toasted.show('<p>' + error.response.data.errorMessage + '</p>', {
            position: 'bottom-center',
            duration: 10000
          });
        }
      });
    },
    filterMember: function filterMember(removedMember, id) {
      this.filteredMember = removedMember.memberNumber;
    },
    limitText: function limitText(count) {
      if (count === 1) {
        var start = this.mkPaymentData.memberFaoNames[0].memberNumber === this.memberNumber ? '★ ' : '';
        start += this.mkPaymentData.memberFaoNames[0].memberFullName;
        return start;
      }
      return 'Selected (' + count + ')';
    },
    callSearchOpenInvoices: function callSearchOpenInvoices(withCache) {
      return payInvoicesService.getOpenInvoices({
        ttl: 10,
        params: {
          pastDueInvoices: false
        }
      });
    },
    setData: function setData(viewData) {
      this.rows = this.setIdReferential(viewData.invoices);
      this.mkPaymentData.memberFaos = viewData.faos;
      this.memberNumber = viewData.memberNumber;
      this.memberName = viewData.memberName;
      this.agreementData = {
        rows: this.rows,
        mkPaymentData: this.mkPaymentData,
        memberData: { number: this.memberNumber, name: this.memberName }
      };
    },
    setIdReferential: function setIdReferential(data) {
      data.forEach(function (invoice, index) {
        invoice.idReferential = 'inv-' + index;
      });
      return data;
    },
    setCreditCardData: function setCreditCardData(data) {
      this.creditCardData = data;
    },
    payInvoices: function payInvoices() {
      var _this3 = this;

      this.$validator.validateAll('paymentMethodCC').then(function (result) {
        if (result) {
          _this3.payInvoicess();
        }
      });
    },
    payInvoicess: function payInvoicess() {
      var _this4 = this;

      this.isPaying = true;
      return payInvoicesService.payInvoices({
        invoicePayments: this.selectedInvoices,
        bankInformationDTO: {
          accountNumber: this.creditCardData.cardNumber,
          accountType: this.creditCardData.cardType,
          creditCardExpireDate: this.creditCardData.expirationMonth + '-' + this.creditCardData.expirationYear,
          nameOnAccount: this.creditCardData.nameOnCard
        }
      }).then(function (success) {
        _this4.handleSuccessPayment();
      }).catch(function (error) {
        var errorMsg = '';
        if (error.response !== undefined && error.response.data !== undefined) {
          errorMsg = error.response.data.errorMessage;
        } else {
          errorMsg = 'There was an error when trying to make a payment';
        }

        _this4.$toasted.show(errorMsg, {
          theme: 'primary',
          position: 'bottom-center',
          duration: 10000
        }, function () {});

        _this4.isPaying = false;
      });
    },
    handleSuccessPayment: function handleSuccessPayment() {
      var _this5 = this;

      if (this.$route.query.callAutoPay !== undefined) {
        this.showPaymentConfirmation(false);
      } else {
        this.getAgreementsEft().then(function (response) {
          if (response && response.agreementEFTs.length) {
            _this5.showModalUAgreements = true;
          } else {
            _this5.showPaymentConfirmation(false);
          }
        }).catch(function (err) {
          err();
        });
      }
    },
    showPaymentConfirmation: function showPaymentConfirmation(updatedEftAgreements) {
      var paymentData = {
        bankInformation: this.getBankInformation(),
        agreements: this.getSelectedAgreementsObject(),
        eftAgreements: updatedEftAgreements ? this.agreementsEftData : [],
        selectedEftAgreements: updatedEftAgreements ? this.selectedEftAgreements : []
      };
      this.showModalUAgreements = false;
      this.goToPaymentConfirmation(paymentData);
    },
    getSelectedAgreementsObject: function getSelectedAgreementsObject() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.agreementData.rows, function (due) {
        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(_this6.selectedAgreements, due.idReferential);
      });
    },
    goToPaymentConfirmation: function goToPaymentConfirmation(paymentData) {
      var confirmParams = {
        paymentData: paymentData,
        confirmTitle: 'Payment Confirmation',
        confirmDescription: 'Make a Payment',
        previousView: 'makeAPayment'
      };
      this.$router.push({ name: 'MakePaymentConfirmation', params: confirmParams });
    },
    getAgreementsEft: function getAgreementsEft() {
      var _this7 = this;

      this.showSpinner = true;
      var responsePromise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        paymentUpdateService.getPaymentEftAgreements({ useCache: false }).then(function (response) {
          _this7.agreementsEftData = response.data;
          resolve(_this7.agreementsEftData);
        }).catch(function (error) {}).finally(function (notif) {
          _this7.showSpinner = false;
          resolve(false);
        });
      });
      return responsePromise;
    },
    handleAgree: function handleAgree(val) {
      this.selectedEftAgreements = val;
      this.showModalUAgreements = false;
      this.showModalUAgreementsTAC = true;
    },
    buildPaymentData: function buildPaymentData() {
      return {
        'agreementNumbers': this.selectedEftAgreements,
        'bankInformationDTO': {
          'accountNumber': this.creditCardData.cardNumber,
          'accountType': this.creditCardData.cardType,
          'creditCardExpireDate': this.creditCardData.expirationMonth + '-' + this.creditCardData.expirationYear,
          'nameOnAccount': this.creditCardData.nameOnCard
        }
      };
    },
    getBankInformation: function getBankInformation() {
      return {
        cardNumber: this.creditCardData.cardNumber.substr(-4),
        cardExpirationDate: this.creditCardData.expirationMonth + '/' + this.creditCardData.expirationYear.toString().substr(-2),
        cardType: this.creditCardData.cardType
      };
    }
  },
  computed: {
    selectedInvoices: {
      get: function get() {
        var invoices = [];
        var invoiceData = {};
        var data = this.getSelectedAgreementsObject();
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(data, function (invoice) {
          invoiceData = {
            referenceNumber: invoice.referenceNumber,
            dueDate: invoice.date
          };
          invoices.push(invoiceData);
        });
        return invoices;
      }
    },
    allMembers: {
      get: function get() {
        var selectableMembers = this.mkPaymentData.memberFaos.slice(0);
        return selectableMembers.concat({ memberNumber: this.memberNumber, memberFullName: this.memberName });
      }
    },
    invoiceTotal: {
      get: function get() {
        var total = 0;
        var data = this.getSelectedAgreementsObject();
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(data, function (invoice) {
          total += invoice.balance;
        });
        return total.toFixed(2);
      }
    },
    isCCDataSet: {
      get: function get() {
        return this.creditCardData.nameOnCard.length > 0 && this.creditCardData.cardNumber.length > 0;
      }
    }
  }
});

/***/ }),

/***/ "cV+n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container",attrs:{"id":"update-agreements-modal"}},[_c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"title-header"},[_c('b',[_vm._v("PAYMENT SUCCESSFUL - THANK YOU!")])]),_vm._v(" "),_c('a',{staticClass:"btn btn-link pull-right close-modal",on:{"click":function($event){_vm.$emit('close')}}},[_c('i',{staticClass:"fa fa-close"})])]),_vm._v(" "),_c('div',{staticClass:"info-modal"},[_c('p',[_vm._v("Use this card for future payments?")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('agreements-eft-table',{attrs:{"agreementData":_vm.agreementsEFTData,"paymentInfo":_vm.paymentInfo},on:{"change":function (value) {_vm.selectedEftAgreements = value}}})],1),_vm._v(" "),_c('div',{staticClass:"modal-footer materialized"},[_c('section',{staticClass:"agreement-message"},[_c('p',[_vm._v("I understand that by clicking Agree I am authorizing 24 Hour Fitness to automatically charge this card for payments based on the agreements above.")])]),_vm._v(" "),_c('section',{staticClass:"button-container"},[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("\n                  Not Now\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",class:{'disabled-agree': !_vm.selectedEftAgreements.length},attrs:{"disabled":!_vm.selectedEftAgreements.length},on:{"click":function($event){_vm.$emit('agreeUpdate', _vm.selectedEftAgreements)}}},[_vm._v("\n                  Agree\n                ")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dBCt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AgreementsEFTTable_vue__ = __webpack_require__("ibtS");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UpdateAgreementsModal',
  props: {
    agreementsEFTData: {
      type: Object,
      required: true
    },
    paymentInfo: {
      type: Object,
      required: true
    }
  },
  components: {
    'agreements-eft-table': __WEBPACK_IMPORTED_MODULE_0__AgreementsEFTTable_vue__["a" /* default */]
  },
  data: function data() {
    return {
      selectedEftAgreements: []
    };
  }
});

/***/ }),

/***/ "ftvu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hmiX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_openInvoicesTable_vue__ = __webpack_require__("n1p0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f6f90890_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_openInvoicesTable_vue__ = __webpack_require__("53iv");
function injectStyle (ssrContext) {
  __webpack_require__("GUdZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_openInvoicesTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f6f90890_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_openInvoicesTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ibtS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AgreementsEFTTable_vue__ = __webpack_require__("pHHs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6abca016_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_AgreementsEFTTable_vue__ = __webpack_require__("KScY");
function injectStyle (ssrContext) {
  __webpack_require__("0gyQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AgreementsEFTTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6abca016_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_AgreementsEFTTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n1p0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_my_account_common_vue__ = __webpack_require__("Uu/Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_my_account_common_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_my_account_common_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_my_account_common__ = __webpack_require__("OrvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_my_account_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_my_account_common__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'invoicesTable',
  props: {
    agreementData: {
      type: Object,
      required: true
    },
    showSpinner: {
      type: Boolean,
      required: false
    },
    filteredMember: {
      type: String,
      required: true
    }
  },
  components: {
    'alert-banner': __WEBPACK_IMPORTED_MODULE_1_my_account_common_vue__["AlertBanner"]
  },
  data: function data() {
    return {
      message: 'Payment Methods',
      firstLoadCompleted: false,
      selectedAgreements: [],
      mkPaymentData: {
        rowsPerPageText: 'Rows: ',
        nextText: '',
        prevText: ''
      },
      tfooter: {
        label: 'Total Balance:',
        value: '0.00'
      },
      columns: [{
        label: '',
        field: 'selected',
        tdClass: 'text-center',
        thClass: 'text-center'
      }, {
        label: 'Member',
        field: 'memberName',
        sortable: true
      }, {
        label: 'Date',
        field: 'date',
        type: 'date',
        tdClass: 'text-center',
        thClass: 'text-center',
        html: '<span class="title" data-title="Date"></span>',
        sortable: true
      }, {
        label: 'Agreement',
        field: 'agreement',
        tdClass: 'text-center',
        thClass: 'text-center',
        sortable: true
      }, {
        label: 'Reference Number',
        field: 'referenceNumber',
        tdClass: 'text-center',
        thClass: 'text-center',
        sortable: true
      }, {
        label: 'Description',
        field: 'description',
        tdClass: 'text-center',
        thClass: 'text-center',
        sortable: true
      }, {
        label: 'Balance',
        field: 'balance',
        type: 'decimal',
        tdClass: 'text-center',
        thClass: 'text-center',
        sortable: false
      }]
    };
  },

  methods: {
    addAgreement: function addAgreement(value, workWith) {
      if (!value.target.checked) {
        this.selectedAgreements = this.selectedAgreements.filter(function (name) {
          return name !== workWith;
        }).map(function (value) {
          return value;
        });
      } else {
        this.selectedAgreements.push(workWith);
      }
      this.$emit('change', this.selectedAgreements);
      this.$forceUpdate();
    },
    getCheckBoxValue: function getCheckBoxValue(props) {
      if (this.filteredMember !== '' && props.row.check === false) {
        return false;
      }
      return this.selectedAgreements.indexOf(props.row.idReferential) > -1;
    }
  },
  watch: {
    filteredRows: function filteredRows() {
      if (!this.firstLoadCompleted && this.filteredRows.length > 0) {
        this.selectAll = true;
        this.firstLoadCompleted = true;
      }
    }
  },
  computed: {
    filteredRows: {
      get: function get() {
        var _this = this;

        var filterResult = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.agreementData.rows, function (row) {
          row.memberName = __WEBPACK_IMPORTED_MODULE_2_my_account_common__["StringUtils"].initCaps(row.memberName);
          if (_this.filteredMember === row.memberNumber) {
            row.check = false;
            var value = { target: { checked: false } };
            _this.addAgreement(value, row.idReferential);
          } else {
            row.check = true;
          }
          return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(_this.agreementData.mkPaymentData.memberFaoNames, 'memberNumber'), row.memberNumber);
        });

        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(filterResult, function (row) {
          var newRow = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(row);
          if (newRow.memberNumber === _this.memberNumber) {
            newRow.memberName = '★ ' + row.memberName;
          }
          return newRow;
        });
      }
    },
    totalValue: {
      get: function get() {
        return '$' + __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sumBy(this.filteredRows, 'balance').toFixed(2);
      }
    },
    selectAll: {
      get: function get() {
        return this.selectedAgreements.length === this.filteredRows.length;
      },
      set: function set(value) {
        this.selectedAgreements = [];
        if (value) {
          this.selectedAgreements = this.filteredRows.map(function (agreement) {
            return agreement.idReferential;
          });
        }
        this.$emit('change', this.selectedAgreements);
        this.$forceUpdate();
      }
    }
  }
});

/***/ }),

/***/ "nCA6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"title-header"},[_vm._v("\r\n              IMPORTANT INFORMATION. PLEASE READ THIS ENTIRE SECTION CAREFULLY\r\n            ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-link pull-right close-modal",on:{"click":function($event){_vm.$emit('cancel')}}},[_c('i',{staticClass:"fa fa-close"})])]),_vm._v(" "),_c('div',{staticClass:"modal-body terms-and-conditions"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.htmlTac)}})]),_vm._v(" "),_c('div',{staticClass:"modal-complement"},[_c('div',{staticClass:"agree-section"},[_c('div',{staticClass:"form-group materialized check-label"},[_c('el-checkbox',{model:{value:(_vm.agreeTAC),callback:function ($$v) {_vm.agreeTAC=$$v},expression:"agreeTAC"}},[_c('p',[_vm._v("I have read and agree to the terms & conditions as stated above.")])])],1)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"materialized"},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.isSavingData},on:{"click":function($event){_vm.$emit('cancel')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{class:{ 'disabled' : !_vm.agreeTAC, 'btn btn-primary' : true },attrs:{"disabled":!_vm.agreeTAC || _vm.isSavingData},on:{"click":function($event){_vm.updatePaymentMethod()}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSavingData),expression:"isSavingData"}],staticClass:"fa fa-cog fa-spin fa-3x fa-fw margin-bottom saving-icon"}),_vm._v("Finish\r\n              ")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pHHs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_my_account_common__ = __webpack_require__("OrvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_my_account_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_my_account_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AgreementsEFTTable',
  props: {
    agreementData: {
      type: Object,
      required: true
    },
    paymentInfo: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      selectedEftAgreements: [],
      moment: __WEBPACK_IMPORTED_MODULE_2_moment___default.a,
      columns: [{
        label: '',
        field: 'selected',
        tdClass: 'text-center',
        thClass: 'text-center'
      }, {
        label: 'Member',
        field: 'memberName',
        tdClass: 'text-center',
        thClass: 'text-center'
      }, {
        label: 'Agreement',
        field: 'agreementId',
        tdClass: 'text-center',
        thClass: 'text-center'
      }, {
        label: 'Payment Method',
        field: 'autoBilled',
        tdClass: 'text-center',
        thClass: 'text-center'
      }]
    };
  },
  mounted: function mounted() {
    this.selectedEftAgreements = this.eftAgreements.map(function (agreement) {
      return agreement.agreementId;
    });
    this.$emit('change', this.selectedEftAgreements);
  },

  methods: {
    addEftAgreement: function addEftAgreement(value, workWith) {
      if (!value.target.checked) {
        this.selectedEftAgreements = this.selectedEftAgreements.filter(function (name) {
          return name !== workWith;
        }).map(function (value) {
          return value;
        });
      } else {
        this.selectedEftAgreements.push(workWith);
      }
      this.$emit('change', this.selectedEftAgreements);
      this.$forceUpdate();
    },
    getCheckBoxValue: function getCheckBoxValue(props) {
      if (this.filteredMember !== '' && props.row.check === false) {
        return false;
      }
      return this.selectedEftAgreements.indexOf(props.row.agreementId) > -1;
    }
  },
  computed: {
    eftAgreements: {
      get: function get() {
        var _this = this;

        if (!this.agreementData.firstName) {
          return [];
        }
        var masterAgreement = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.agreementData.agreementEFTs, function (agreement) {
          var agreementData = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(agreement);
          agreementData.memberName = __WEBPACK_IMPORTED_MODULE_1_my_account_common__["StringUtils"].initCaps(_this.agreementData.firstName + ' ' + _this.agreementData.lastName);
          agreementData.mainUser = true;
          agreementData.autoBilled = 'x-' + _this.paymentInfo.cardNumber;
          agreementData.accountType = _this.paymentInfo.cardType;
          if (_this.paymentInfo.cardExpirationDate) {
            agreementData.cardExpirationDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_this.paymentInfo.cardExpirationDate, 'MM/YYYY').endOf('month');
            agreementData.cardExpirationDateText = agreementData.cardExpirationDate.format('MM/YYYY');
            agreementData.cardExpirationDateValue = agreementData.cardExpirationDate.valueOf();
          }
          agreementData.selected = true;
          return agreementData;
        });
        var faoAgreements = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.agreementData.memberFaos, function (owner) {
          return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(owner.agreementEFTs, function (agreement) {
            var agreementData = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(agreement);
            agreementData.memberName = __WEBPACK_IMPORTED_MODULE_1_my_account_common__["StringUtils"].initCaps(owner.firstName + ' ' + owner.lastName);
            agreementData.mainUser = false;
            agreementData.autoBilled = 'x-' + _this.paymentInfo.cardNumber;
            agreementData.accountType = _this.paymentInfo.cardType;
            if (_this.paymentInfo.cardExpirationDate) {
              agreementData.cardExpirationDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_this.paymentInfo.cardExpirationDate, 'MM/YYYY').endOf('month');
              agreementData.cardExpirationDateText = agreementData.cardExpirationDate.format('MM/YYYY');
              agreementData.cardExpirationDateValue = agreementData.cardExpirationDate.valueOf();
            }
            agreementData.selected = true;
            return agreementData;
          });
        });
        return masterAgreement.concat([].concat.apply([], faoAgreements));
      }
    }
  }
});

/***/ }),

/***/ "ra/4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uKrX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vPWJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_CommonBilling__ = __webpack_require__("vGe0");
var _this = this;


var paymentUpdateService = __WEBPACK_IMPORTED_MODULE_0_CommonBilling__["a" /* ServiceContainer */].paymentUpdateService;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'msomodal',
  props: {
    paymentData: {
      type: Object,
      required: true
    },
    htmlTac: {
      type: String,
      default: ''
    }
  },
  mounted: function mounted() {
    document.addEventListener('keyup', this.listener);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keyup', this.listener);
  },
  data: function data() {
    return {
      agreeTAC: false,
      isSavingData: false
    };
  },

  methods: {
    listener: function listener(evt) {
      if (evt.keyCode === 27) {
        _this.$emit('close');
      }
    },
    updatePaymentMethod: function updatePaymentMethod() {
      var _this2 = this;

      this.isSavingData = true;
      paymentUpdateService.updatePaymentInfo(this.paymentData).then(function (response) {
        _this2.$emit('close');
      }).catch(function (error) {
        if (error.response !== undefined && error.response.data.errorMessage !== undefined) {
          _this2.$toasted.show('<p>' + error.response.data.errorMessage + '</p>', {
            position: 'bottom-center',
            duration: 10000
          });
        } else {
          _this2.$toasted.show('<p>Your payment info was not updated. ' + 'Please try again. If you are having trouble with this process please call Member Services at 1-800-432-6348</p>', {
            position: 'bottom-center',
            duration: 10000
          });
        }
      }).finally(function (notif) {
        _this2.isSavingData = false;
      });
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/MakeAPayment.js